import { getMobileAppDetails } from '@taxfix/scouts-helpers'
import {
    Button,
    Flexer,
    ModalActionsLegacy as ModalActions,
    ModalBodyLegacy as ModalBody,
    ModalFooterLegacy as ModalFooter,
    ModalHeaderLegacy as ModalHeader,
    ModalLegacy as Modal,
    ModalTitleLegacy as ModalTitle,
    Paragraph,
} from '@taxfix/scouts-ui'

const { getShouldUpdateApp, isIos, isAndroid } = getMobileAppDetails()

const messages = {
    heading: 'Update Required',
    body: 'We have released a new version of the Taxfix app. Please update the app to continue using it.',
    btnAppStore: 'Update on App Store',
    btnGooglePlay: 'Update on Google Play',
}

const links = {
    appStore: 'https://apps.apple.com/gb/app/taxscouts-uk-tax-returns/id6484507873',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.taxscouts.uk.customer&hl=en',
}

export const MobileVersionUpdateModal = ({ mobileAppTargetVersion }: { mobileAppTargetVersion: string }) => {
    if (!getShouldUpdateApp(mobileAppTargetVersion)) return null

    return (
        <Modal>
            <ModalHeader>
                <ModalTitle>{messages.heading}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Paragraph>{messages.body}</Paragraph>
            </ModalBody>
            <ModalFooter>
                <ModalActions>
                    {isIos && (
                        <Button size="large" as="a" href={links.appStore} target="_blank" rel="noopener noreferrer">
                            <Flexer justifyCenter>{messages.btnAppStore}</Flexer>
                        </Button>
                    )}

                    {isAndroid && (
                        <Button size="large" as="a" href={links.googlePlay} target="_blank" rel="noopener noreferrer">
                            <Flexer justifyCenter>{messages.btnGooglePlay}</Flexer>
                        </Button>
                    )}
                </ModalActions>
            </ModalFooter>
        </Modal>
    )
}
